import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "./context/LanguageContext";
import { UserProvider } from "./context/UserContext";
import AppBar from "./navigation/AppBar";
import AnimatedRoutes from "./navigation/AnimatedRoutes";
import Footer from "./navigation/Footer";
import PageMetadata from "./components/PageMetadata";
import "./App.css";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const sectionId = decodeURIComponent(hash.slice(1));
      const animationFrame = window.requestAnimationFrame(() => {
        document.getElementById(sectionId)?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });

      return () => window.cancelAnimationFrame(animationFrame);
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

function App({ language = "en" }) {
  const location = useLocation();
  const hideFooterRoutes = ["/profile", "/profile/subscription", "/profile/devices", "/profile/free-trial", "/profile/password"];
  const hideFooter = hideFooterRoutes.some((route) => location.pathname.startsWith(route));

  return (
    <UserProvider>
      <LanguageProvider language={language}>
        <PageMetadata />
        <AppBar />
        <ScrollToTop />
        <main id="main-content">
          <AnimatedRoutes />
        </main>
        {!hideFooter && <Footer />}
      </LanguageProvider>
    </UserProvider>
  );
}

export default App;
